import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';

import { ORDERS_REJECTED_FULFILLMENT_PAGE_URL } from '../../../../../routes/constants';

export const RejectedFulfillment = ({ storeName, orderNumber, closeModal }) => {
  const history = useHistory();

  const onReviewClick = useCallback(() => {
    closeModal();
    history.push(ORDERS_REJECTED_FULFILLMENT_PAGE_URL);
  }, [history, closeModal]);

  return (
    <FormattedMessage
      defaultMessage='Fulfillment of Order <b>#{orderNumber}</b> was rejected by <b>{storeName}</b>. <l>Review.</l>'
      description='Message letting client know what fulfillment was rejected and by whom'
      id='ZbIIGX'
      values={{
        storeName,
        orderNumber,
        l: (chunks) => (
          <Button onClick={onReviewClick} theme='link'>
            {chunks}
          </Button>
        ),
        b: (chunks) => <b>{chunks}</b>,
      }}
    />
  );
};

RejectedFulfillment.propTypes = {
  storeName: PropTypes.string.isRequired,
  orderNumber: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
};
